<template>
  <div class="modal" v-bind:class="{ 'is-active': isModalActive }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ CONSTANTS.getCopy('CONSULTREASON_REASON_INQUIRY') }}</p>
        <button class="delete" aria-label="close" @click="close"></button>
      </header>
      <section class="modal-card-body is-flex-column-center consult-reason">
        <div class="form-section">
          <label class="label">
            <input type="radio" name="option" ref="option1" @click="optionSelected = 1" checked />
            {{ CONSTANTS.getCopy('CONSULTREASON_SELECT_REASON_INQUIRY') }}
          </label>
          <div v-if="optionSelected === 1" class="is-flex-column-center ptop-1">
            <div v-for="(reason, index) in reasons" :key="reason.idQuery">
              <div class="is-flex-row-center space-between">
                <span> {{ reason.name }}</span>
                <span> {{ reason.description }} </span>
                <p class="control">
                  <a v-if="availableReasons[index]" class="button is-success" title="Deseleccionar">
                    <span class="icon" @click="toggleReason(index)">
                      <i class="fas fa-toggle-on"></i>
                    </span>
                  </a>
                  <a v-if="!availableReasons[index]" class="button bg-warning" title="Seleccionar">
                    <span class="icon" @click="toggleReason(index)">
                      <i class="fas fa-toggle-off"></i>
                    </span>
                  </a>
                </p>
              </div>
              <hr />
            </div>
          </div>
          <label class="label">
            <input type="radio" name="option" ref="option2" @click="optionSelected = 2" />
            {{ CONSTANTS.getCopy('CONSULTREASON_INPUT_REASON_INQUIRY') }}
          </label>
          <div v-if="optionSelected === 2" class="is-flex-column-center">
            <input type="text" :class="{ 'input-error': showErrors && !consultTitle }"
                   v-bind:placeholder="CONSTANTS.getCopy('CONSULTREASON_TITLE_INQUIRY_PLACEHOLDER') " v-model="consultTitle" />
            <textarea class="mtop-1" :class="{ 'input-error': showErrors && !consultDescription }"
                      v-bind:placeholder="CONSTANTS.getCopy('CONSULTREASON_DESCRIPTION_INQUIRY_PLACEHOLDER') " v-model="consultDescription"></textarea>
            <div class="mtop-1 button is-primary" @click="newReason">
              <span class="icon"><i class="fas fa-check fa-lg"></i></span>
              <span>{{ CONSTANTS.getCopy('CONSULTREASON_BUTTON_ADD_REASON') }}</span>
            </div>
          </div>
        </div>
        <div class="field confirm-footer is-grouped-right">
          <div class="button is-dark" @click="cancel">
            <span class="icon"><i class="fas fa-times fa-lg"></i></span>
            <span>{{ CONSTANTS.getCopy('CONSULTREASON_BUTTON_CANCEL') }}</span>
          </div>
          <div class="button is-primary" @click="accept">
            <span class="icon"><i class="fas fa-check fa-lg"></i></span>
            <span>{{ CONSTANTS.getCopy('CONSULTREASON_BUTTON_ACCEPT') }}</span>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showModal: false,
      optionSelected: 1,
      consultTitle: null,
      consultDescription: null,
      showErrors: false,
      availableReasons: [],
      reasons: [],
      idClient: this.$route.params.client,
      selectedReasons: []
    }
  },
  created () {
    Event.$on('showConsultReason', () => {
      this.showModal = true
      this.getReasons()
    })
  },
  computed: {
    isModalActive () {
      return this.showModal
    }
  },
  methods: {
    close () {
      this.showModal = !this.showModal
    },
    accept () {
      if (this.optionSelected === 2) {
        if (!this.consultTitle || !this.consultDescription) {
          this.showErrors = true
          return
        }
      }

      this.setSelectedReasons()
      this.showModal = false
      this.clean()
      Event.$emit('closeConsultReason', [true, this.selectedReasons])
    },
    clean () {
      this.consultTitle = null
      this.consultDescription = null
      this.optionSelected = 1
      this.$refs.option1.checked = true
      this.$refs.option2.checked = false
      this.showErrors = false
    },
    cancel () {
      this.showModal = false
      this.clean()
      Event.$emit('closeConsultReason', false)
    },
    toggleReason (index) {
      this.$forceUpdate()
      this.availableReasons[index] = !this.availableReasons[index]
    },
    getReasons () {
      this.api.post('/ChatsAgentGetQueries', { idClient: this.idClient }).then(response => {
        this.reasons = response.queries

        this.availableReasons = []
        this.reasons.forEach(() => {
          this.availableReasons.push(false)
        })
      })
    },
    newReason () {
      if (!this.consultTitle || !this.consultDescription) {
        this.showErrors = true
        return
      }
      this.api.post('/ChatsAgentRegisterQuery', { idClient: this.idClient, name: this.consultTitle, description: this.consultDescription }).then(() => {
        this.getReasons()
        this.clean()
      })
    },
    setSelectedReasons () {
      this.selectedReasons = []
      this.availableReasons.forEach((reason, index) => {
        if (reason) {
          this.selectedReasons.push({
            idClient: this.idClient,
            idQuery: this.reasons[index].idQuery,
            name: this.reasons[index].name,
            description: this.reasons[index].description
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialogs/ConsultReason.vue